import React from 'react';
// importing images
import image1 from '../img/portfolio/1.png'
import image2 from '../img/portfolio/2.png'
import image3 from '../img/portfolio/3.png'
import image4 from '../img/portfolio/4.png'
// import link
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { transition1 } from '../transitions';

const Portfolio = () => {
  const downloadPortfolio = () => {
    // You can replace the link below with the actual link to your PDF file
    const pdfLink = 'https://drive.google.com/file/d/1-xSwTrHSQoDp6SmA9TAhCzrQ3ogqzUwK/view?usp=sharing';
    
    // Create a temporary link element
    const link = document.createElement('a');
    link.href = pdfLink;
    link.download = 'portfolio.pdf';

    // Trigger a click on the link to start the download
    document.body.appendChild(link);
    link.click();

    // Clean up the link element
    document.body.removeChild(link);
  };

  return (
    <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className='section bg-[#7F00FF]'>
      <div className='container mx-auto h-full relative'>
        <div className='flex flex-col lg:flex-row h-full items-center justify-start gap-x-24 text-center lg:text-left pt-24 lg:pt-36 pb-8'>
          {/* text */}
          <div
            initial={{ opacity: 0, y: '-80%' }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: '-80%' }}
            transition={transition1}
            className='flex flex-col lg:items-start'>
            <h1 className='h1'>Portfolio</h1>
            <p className='mb-12 max-w-sm'>
              Three years of experience as a committed and meticulous
              wedding photographer. Contributed in the expansion of a
              family-owned medical company. A professional with over
              three years of experience in online businesses who's
              creative, highly structured, and efficient. Always on time
              and take responsible care of everything
            </p>
            <button className='btn mb-[30px] mx-auto lg:mx-0' onClick={downloadPortfolio}>
              Download Portfolio
            </button>
          </div>
          {/* images grid */}
          <motion.div
            initial={{ opacity: 0, y: '-80%' }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: '-80%' }}
            transition={transition1}
            className='grid grid-cols-2 lg:gap-2'>
            {/* images */}
            <div className='max-w-[250px] lg:max-w-[320px] h-[187px] lg:h-[220px] bg-accent overflow-hidden'>
              <img className='object-cover h-full lg:h-[220px] hover:scale-110 transition-all duration-500' src={image1} alt='' />
            </div>
            <div className='max-w-[250px] lg:max-w-[320px] h-[187px] lg:h-[220px] bg-accent overflow-hidden'>
              <img className='object-cover h-full lg:h-[220px] hover:scale-110 transition-all duration-500' src={image2} alt='' />
            </div>
            <div className='max-w-[250px] lg:max-w-[320px] h-[187px] lg:h-[220px] bg-accent overflow-hidden'>
              <img className='object-cover h-full lg:h-[220px] hover:scale-110 transition-all duration-500' src={image3} alt='' />
            </div>
            <div className='max-w-[250px] lg:max-w-[320px] h-[187px] lg:h-[220px] bg-accent overflow-hidden'>
              <img className='object-cover h-full lg:h-[220px] hover:scale-110 transition-all duration-500' src={image4} alt='' />
            </div>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};

export default Portfolio;
